"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./drawer.css");

exports.default = {
  drawer: 'pf-c-drawer',
  drawerPanel: 'pf-c-drawer__panel',
  drawerContent: 'pf-c-drawer__content',
  drawerPanelBody: 'pf-c-drawer__panel-body',
  modifiers: {
    'expanded': 'pf-m-expanded',
    'inline': 'pf-m-inline',
    'noPadding': 'pf-m-no-padding'
  }
};